import type { WizardI18nConfig } from "@/app/wizard/wizard-types";

// Cookie configuration (same for all products)
export const LOCALE_COOKIE_NAME = "NEXT_LOCALE";
export const LOCALE_COOKIE_MAX_AGE = 31536000; // 1 year in seconds

// Magnolia CMS language query parameter
export const MAGNOLIA_LANG_PARAM = "lang";
export const DEFAULT_FALLBACK_LOCALE = "en-GB";

/**
 * Default i18n configuration fallback
 * Used when wizard definition doesn't have i18n config
 * Note: supportedLocales is NOT stored here - it's derived from languages array
 */
export const DEFAULT_I18N_CONFIG: WizardI18nConfig = {
  defaultLocale: "en",
  languages: [
    {
      code: "en",
      backendLocaleCode: DEFAULT_FALLBACK_LOCALE,
      name: "English",
      flag: "🇬🇧",
      currency: "GBP",
      timeZone: "Europe/London",
    },
  ],
};

/**
 * Map an app locale code to a locale date-fns actually publishes.
 *
 * date-fns only ships region-qualified English locales (`en-GB`, `en-US`, ...),
 * so the bare `en` app code makes the component library's
 * `import(\`date-fns/locale/${locale}\`)` throw "Cannot find module './en'" and
 * silently fall back to its US default. Every other locale code is passed
 * through unchanged because date-fns publishes those unqualified (e.g. `es`).
 */
export function getDateLocaleCode(locale: string): string {
  return locale === "en" ? DEFAULT_FALLBACK_LOCALE : locale;
}
